import type { Messages } from "../types";

/** Afrikaans — written for the picker. Missing keys fall back to English. */
export const af: Messages = {
  common: {
    brand: "UN8",
    brandTag: "Eksklusiewe Christen-hofmakery",
    continue: "Gaan voort",
    next: "Volgende",
    leave: "Verlaat",
    leaveForNow: "Verlaat vir eers",
    yes: "Ja",
    no: "Nee",
    goBack: "Gaan terug",
    saving: "Stoor…",
    submitting: "Stuur…",
    pleaseWait: "Wag asseblief…",
    ellipsis: "…",
    male: "Man",
    female: "Vrou",
    phases: {
      gate: "Hek",
      verify: "Verifieer",
      setup: "Opstel",
      profile: "Profiel",
    },
    storageQuota:
      "Hierdie foon het nie meer spasie vir gestoorde antwoorde nie. Maak spasie oop en probeer weer.",
    storageDisabled:
      "Hierdie blaaier sal nie jou antwoorde stoor nie. Skakel privaatmodus af, of laat werfdata toe, en herlaai dan.",
    charMeta: "{len}/{min} min · {current}/{max}",
    charMetaMin: "min {min} karakters",
  },

  welcome: {
    promise: "Ons doel is dat jy hierdie app so gou moontlik uitvee.",
    sub: "Vier mense per week. Regte gesigte. Hofmakery tot die huwelik — dan vee die app uit.",
    signedInAs: "Aangemeld as {email}",
    liveServer: " · lewendige bediener",
    deviceOnly: " · net hierdie toestel",
    migrateOffer:
      "Hierdie toestel het nog ’n plaaslike profiel. Laai dit op na die gedeelde bediener sodat ander fone jou ná moderering kan sien? Niks word opgelaai tot jy kies nie.",
    uploadLocalProfile: "Laai my plaaslike profiel op",
    keepOnDevice: "Hou dit net op hierdie toestel",
    migrateNeedGender: "Kies eers Man of Vrou in jou profiel.",
    migrateDone:
      "Profielteks is opgelaai. Laai ID, video en foto’s weer op sodat moderering dit kan nagaan.",
    deleteConfirm:
      "Vee jou rekening, alle boodskappe en alle media (insluitend ID en video) permanent van die bediener af?",
    accountDeleted: "Rekening uitgevee.",
    begin: "Ek is in",
    betaTitle: "Welcome UN8 Beta Tester!",
    betaBody:
      "This is the closed web test. Use the app in this browser. Play Billing and TestFlight are not open yet — there is no web checkout.",
    tryMatching: "Open matching",
    reportBug: "Report a bug",
    startFresh: "Start this phone fresh",
    continueOnboarding: "Gaan voort met opstel",
    logIn: "Meld aan",
    logOut: "Meld af",
    reviewConsole: "Hersieningskonsole",
    matching: "Passing",
    deleteMyAccount: "Vee my rekening uit",
  },

  intro: {
    title: "Welkom by UN8",
    text: "Ernstige geloof. Regte gesigte. Hofmakery tot die huwelik — dan vee die app uit.",
    videoHint: "Sit public/intro.mp4 hier om ’n kort handelsmerkvideo te speel.",
    continue: "Ek is in",
    skip: "Slaan oor",
    betaLine: "Welcome UN8 Beta Tester!",
  },

  faith: {
    eyebrow: "Eerste.",
    title: "Volg jy Jesus?",
    text: "UN8 is vir volgelinge van Jesus Christus.",
    yesTitle: "Ja",
    yesBody: "",
    noTitle: "Nee",
    noBody: "",
    respectTitle: "Met respek",
    respectBody:
      "UN8 is vir een gemeenskap gebou, en ons wil eerder eerlik wees as jou tyd mors. Gebruik Verlaat hieronder, of Terug, as dit nie jou tuiste is nie.",
    sharedTitle: "Gedeelde fondament",
    sharedBody: "Geloof is hier nie ’n etiket nie. Dit is die grond waarop julle ontmoet.",
    hintNotChristian:
      "UN8 is vir volgelinge van Jesus Christus. Tik Verlaat hieronder, of kies die Christen-opsie as dit jy is.",
    hintUnset:
      "Tik “Ek is ’n Christen” om voort te gaan, of Verlaat / Terug as dit nie jou tuiste is nie.",
  },

  rules: {
    eyebrow: "Dan dit.",
    title: "Drie reëls. Geen uitsonderings.",
    text: "Bevestig elke reël. Al drie is verpligtend. Oortredings lei tot permanente verwydering. Vals profiele word vir altyd verban.",
    agreeContinue: "Ek stem saam — gaan voort",
    respectful: {
      title: "Wees respekvol",
      description: "Praat en tree op met waardigheid. Elke mens hier is na God se beeld gemaak.",
    },
    noSexualContent: {
      title: "Geen seksuele inhoud",
      description: "Geen eksplisiete foto’s, boodskappe of versoeke. Reinheid is hier nie opsioneel nie.",
    },
    noDominance: {
      title: "Moenie oorheers of beheer nie",
      description: "Geen dwang, manipulasie of druk. Liefde beheer nie.",
    },
    hint: "Merk al drie beloftes voordat jy voortgaan.",
  },

  intent: {
    eyebrow: "",
    title: "Waarna soek jy?",
    text: "",
    marriage: {
      label: "’n Lewensmaat",
      description: "",
    },
    discernment: {
      label: "Ernstige onderskeiding",
      description: "",
    },
    notCasual: {
      label: "Niks los nie",
      description: "",
    },
    hint: "Kies een.",
  },

  account: {
    eyebrow: "Rekening",
    title: "Wat is jou e-pos?",
    text: "",
    recoveryTitle: "Stoor jou herstelkode",
    recoveryText:
      "Net een keer gewys. Sonder dit kan ’n verlore wagwoord in hierdie toetssluiting nie herstel word nie.",
    savedContinue: "Ek het dit gestoor — gaan voort",
    handle: "E-pos",
    handlePlaceholder: "jy@voorbeeld.com",
    passphrase: "Wagwoord",
    passphrasePlaceholder: "Minstens 8 karakters",
    signedInTitle: "Aangemeld",
    signedInBody: "{email} · {userId}",
    trustTitle: "Vertrouestandaard",
    trustBody:
      "Geen profiel is sigbaar tot identiteitsverifikasie klaar is en moderering jou goedkeur nie.",
    continueToVerification: "Gaan voort na verifikasie",
    hintEmail: "Tik ’n e-posadres wat @ insluit.",
    hintPassword: "Kies ’n wagwoord van minstens 8 karakters.",
  },

  verify: {
    intro: {
      eyebrow: "Verifikasie",
      title: "Vertroue is die hek",
      text: "Laai ’n staats-ID, ’n bevestigingsvideo en {min}–{max} regte foto’s op. Alles gaan eers in ’n hersieningsry voor jou profiel kan verskyn.",
      whyTitle: "Hoekom ons verifieer",
      whyBody:
        "Katvisvang en halfwaarhede hoort nie hier nie. Vals profiele word permanent verban. Media bly pending_review tot dit goedgekeur is.",
      start: "Begin verifikasie",
    },
    steps: {
      id: {
        title: "Staats-ID",
        description: "Paspoort of nasionale ID — kamera of lêer-oplaai.",
      },
      video: {
        title: "Bevestigingsvideo",
        description: "’n Kort opname wat wys jy is teenwoordig.",
      },
      photos: {
        title: "Regte foto’s",
        description: "Vier tot ses duidelike foto’s van jouself.",
      },
      review: {
        title: "Integriteithersiening",
        description: "Oplaaie bly pending_review tot personeel bevestig.",
      },
    },
    id: {
      eyebrow: "Stap 1 van 4",
      title: "Staats-ID",
      text: "Neem of laai jou paspoort of nasionale ID op. Niks word openbaar geplaas nie — status bly pending_review tot personeel bevestig.",
      savedTitle: "ID gestoor",
      savedBody:
        "Volgende is ’n kort bevestigingsvideo van jou gesig, dan {min}–{max} regte foto’s van jouself. Gaan voort ontsluit wanneer hierdie ID as gestoor wys.",
      hint: "Neem of laai ’n foto van jou staats-ID op, en wag tot dit sê gestoor.",
    },
    video: {
      eyebrow: "Stap 2 van 4",
      title: "Bevestigingsvideo",
      text: "Neem ’n kort knippie (ongeveer {seconds} sekondes) of laai een op. Kyk na die kamera. Praat duidelik. Dit bewys jy is teenwoordig — nie ’n afgeskraapte galery nie.",
      hint: "Neem ’n kort bevestigingsvideo, en wag tot dit sê gestoor.",
    },
    photos: {
      eyebrow: "Stap 3 van 4",
      title: "Jou beste foto.",
      text: "Een is genoeg om te begin.",
      continueToReview: "Volgende",
      hint: "Voeg {min} tot {max} duidelike foto’s van jouself by. Gaan voort ontsluit wanneer hulle gestoor is.",
    },
    review: {
      eyebrow: "Stap 4 van 4",
      title: "Integriteithersiening",
      text: "Media staan in die ry as pending_review{underUser}. Passings en hou-vans gebruik dieselfde id.",
      underUser: " onder gebruiker {userId}",
      governmentId: "Staats-ID",
      confirmationVideo: "Bevestigingsvideo",
      photos: "Foto’s",
      missing: "Ontbreek",
      filesReady: "{count} lêers gereed",
      submittedTitle: "Ingedien vir hersiening",
      submittedText:
        "Aansoek-id is dieselfde as outentieke gebruiker-id sodat goedkeur → poel en wedersydse hou-vans in lyn bly.",
      submitContinue: "Dien in en gaan voort",
    },
  },

  setup: {
    eyebrow: "Rekeningopstel",
    title: "’n Paar vrae.",
    text: "Nie ’n sensus nie. Sê genoeg dat iemand eg jou kan vind.",
    beginSetup: "Kom ons begin",
    pillars: {
      faith: { name: "Geloof", text: "Hoekom jy Christus volg." },
      character: {
        name: "Karakter",
        text: "Lojaliteit, eerlikheid, passie, toewyding — gegradeer 1–10.",
      },
      story: { name: "Verhaal", text: "Wie jy is en wat jy soek." },
      life: { name: "Lewe", text: "Stokperdjies, lees, en roeping." },
    },
    whyChristian: {
      eyebrow: "Geloof",
      title: "Hoekom Jesus?",
      text: "Die ware rede. Nie die Sondagskool-een nie.",
      label: "Jou antwoord",
      placeholder: "Die ware rede. Nie die Sondagskool-een nie.",
      hint: "’n Sin is genoeg.",
    },
  },

  scales: {
    eyebrow: "Karakterskale",
    title: "Kom ons wees eerlik!",
    text: "",
    loyalty: {
      label: "Lojaliteit",
      hint: "Wees eerlik — hoe getrou staan jy by dié wat jy liefhet?",
    },
    honesty: {
      label: "Eerlikheid",
      hint: "Hoe konsekwent vertel jy die volle waarheid?",
    },
    passion: {
      label: "Passie",
      hint: "Oortuiging en diepte — nie vertoning nie.",
    },
    commitment: {
      label: "Toewyding",
      hint: "Hoe gereed is jy om iets te bou wat hou?",
    },
    social: {
      label: "Sosiaal",
      hint: "Stil aande aan die een kant. ’n Vol kamer aan die ander.",
    },
    creativity: {
      label: "Kreatiwiteit",
      hint: "Hoe vry maak en bedink jy?",
    },
    humor: {
      label: "Humor",
      hint: "Hoe maklik lag jy — en laat ander lag?",
    },
    hint: "Stel elke getal.",
  },

  about: {
    eyebrow: "Oor jou",
    title: "Wie is jy, regtig?",
    text: "",
    label: "Oor jou",
    placeholder: "’n Paar sinne. Dié wat jy vir ’n vriend sou sê.",
    hint: "’n Sin is genoeg.",
  },

  looking: {
    eyebrow: "Metgesel",
    title: "Waarna soek jy?",
    text: "",
    partnerCountry: "Voorkeurland vir ’n metgesel",
    partnerCountryHint:
      "As jy “dieselfde as myne” of ’n spesifieke land kies, word kandidate uit ander lande weggesteek. ’n Ontbrekende land op hulle profiel blokkeer nooit (onvolledig, nie ’n wanpassing nie).",
    partnerCountrySame: "Dieselfde land as ek",
    partnerCountrySameBody: "Wys net mense in my land.",
    partnerCountryAny: "Enige land",
    partnerCountryAnyBody: "Geen landfilter — verwantskap besluit.",
    partnerCountrySpecific: "’n Spesifieke land",
    partnerCountrySpecificBody: "Wys net mense uit die land wat ek kies.",
    partnerCountryPick: "Land",
    label: "Gewenste karaktertrekke",
    placeholder: "Karakter. Nie ’n inkopielys nie.",
    hint: "’n Sin is genoeg.",
  },

  loveReady: {
    eyebrow: "Drempel",
    title: "Gereed om die liefde van jou lewe te ontmoet?",
    text: "",
    yesTitle: "Ja",
    yesBody: "",
    noTitle: "Nog nie",
    noBody: "",
    comeBackTitle: "Kom terug wanneer jy gereed is",
    comeBackBody:
      "UN8 is vir mense wat bereid is om te ontmoet — nie om opsies te versamel nie. Gebruik Verlaat hieronder as jy nou wil stop. Jou antwoorde is op hierdie foon gestoor.",
    hintNo:
      "Net “Ja” gaan voort. As jy nie gereed is nie, tik Verlaat vir eers — jou antwoorde bly op hierdie foon.",
    hintUnset: "Tik Ja as jy gereed is om iemand vir die huwelik te ontmoet.",
  },

  lifestyle: {
    eyebrow: "Lewenstyl",
    title: "Wat doen jy eintlik?",
    text: "Pret, dan werk. Dis al.",
    anythingInteresting: "Enigiets anders interessant?",
    anythingInterestingPlaceholder:
      "Opsioneel — eienaardighede, gewoontes of lewensbesonderhede wat iemand help om jou te ken.",
    anythingInterestingHint: "Opsioneel. Word by jou “oor jou”-teks gewys.",
    hobbies: "Huidige sport of stokperdjies",
    hobbiesPlaceholder: "Wat jy vir pret doen.",
    reading: "Lees jy?",
    readingHint: "1 = byna nooit · 10 = daagliks, diep lees",
    profession: "Beroep / sektor",
    professionPlaceholder: "Wat jy vir werk doen.",
    hintHobbies: "Noem een ding wat jy werklik doen.",
    hintReading: "Skuif “Lees jy?” sodat ’n getal van 1 tot 10 wys.",
    hintProfession: "’n Kort woord is genoeg.",
  },

  faithDepth: {
    eyebrow: "Passing · Geloof",
    title: "Hoe sentraal is jou geloof?",
    text: "God dien — hoe belangrik in jou lewe? Antwoord eerlik. Passing gebruik dit vir diepte, nie vertoning nie.",
    serving: "God dien — belangrikheid",
    servingHint: "10% … 100%. Skuif in stappe van 10.",
    keepsCommandments: "Hou jy die gebooie?",
    grewUpInChurch: "Het jy in die kerk grootgeword?",
    churchAttendance: "Kerkbywoning",
    frequent: { label: "Gereeld", hint: "Gereelde byeenkoms met die liggaam van Christus." },
    seldom: { label: "Selde", hint: "Af en toe, nie ’n weeklikse ritme nie." },
    never: { label: "Nooit", hint: "Woon tans nie by nie." },
    spreadsGospel: "Dra jy die evangelie uit?",
    hasIdols: "Het jy afgode?",
    hintServing: "Skuif hoe belangrik dit is om God in jou lewe te dien.",
    hintCommandments: "Antwoord of jy die gebooie hou — Ja of Nee.",
    hintGrewUp: "Antwoord of jy in die kerk grootgeword het — Ja of Nee.",
    hintAttendance: "Kies hoe gereeld jy kerk bywoon.",
    hintGospel: "Antwoord of jy die evangelie deel — Ja of Nee.",
    hintIdols: "Antwoord of jy afgode het — Ja of Nee.",
  },

  character: {
    eyebrow: "Passing · Karakter",
    title: "Wie jy by die huis is",
    text: "Karakter vir hofmakery — vredemaak, maniere, eerlikheid. Opgeblaasde antwoorde pas jou later verkeerd.",
    peacemaker: "Is jy ’n vredemaker?",
    homebuilder: "Is jy ’n huisbouer?",
    humorous: "Is jy humoristies?",
    caring: "Omgee en liefdevol?",
    peacefulHome: "Wil jy ’n vreedsame huis — vry van baklei?",
    manners: "Goeie maniere?",
    honestyRating: "Eerlikheidsgradering op hierdie vraelys",
    honestyHint: "1–10 — hoe eerlik antwoord jy?",
    hintPeacemaker: "Antwoord elke Ja of Nee, begin by vredemaker.",
    hintHomebuilder: "Antwoord of jy ’n huisbouer is.",
    hintHumorous: "Antwoord of jy humoristies is.",
    hintCaring: "Antwoord of jy omgee en liefdevol is.",
    hintPeaceful: "Antwoord of jy ’n vreedsame huis wil hê.",
    hintManners: "Antwoord of jy goeie maniere het.",
    hintHonesty: "Skuif jou eerlikheidsgradering van 1 tot 10.",
  },

  history: {
    eyebrow: "Passing · Geskiedenis",
    title: "Verlede en gereedheid",
    text: "Middels, kinderjare, littekens, en of jy gereed is vir ’n blywende verhouding. Waarheid hier beskerm julle albei.",
    marijuana: "Het jy dagga gebruik?",
    lsd: "Het jy LSD gebruik?",
    otherDrugs: "Het jy ander dwelms gebruik?",
    addicted: "Was jy verslaaf?",
    childhood: "Stabiele, liefdevolle kinderjare?",
    scars: "Enige littekens / beskadig?",
    lasting: "Gereed vir ’n blywende verhouding?",
    hintStart: "Antwoord elke Ja of Nee op hierdie bladsy, begin bo.",
    hintLsd: "Antwoord die LSD-vraag — Ja of Nee.",
    hintOtherDrugs: "Antwoord of jy ander dwelms gebruik het.",
    hintAddicted: "Antwoord of jy verslaaf was.",
    hintChildhood: "Antwoord of jou kinderjare stabiel en liefdevol was.",
    hintScars: "Antwoord of jy littekens dra.",
    hintLasting: "Antwoord of jy gereed is vir ’n blywende verhouding.",
  },

  appearance: {
    eyebrow: "Passing · Voorkoms",
    title: "Tatoeëermerke",
    text: "Jou tatoeëermerke, en of tatoeëermerke op ’n metgesel vir jou aanvaarbaar is.",
    hasTattoos: "Het jy tatoeëermerke?",
    acceptsPartner: "Aanvaar tatoeëermerke op ’n metgesel?",
    hintHas: "Sê of jy tatoeëermerke het — Ja of Nee.",
    hintAccepts: "Sê of tatoeëermerke op ’n metgesel vir jou aanvaarbaar is.",
  },

  home: {
    eyebrow: "Passing · Huis en grond",
    title: "Grond, vaardighede, selfvoorsiening",
    text: "Kruie, kos kweek, vrugtebos, voorbereiding, gemeenskapsboerdery, preserveer, oorlewing — en enige spesiale vaardighede.",
    herbKnowledge: "Kruiekennis?",
    plantOwn: "Plant jy jou eie vrugte en groente?",
    fruitForest: "Belangstel in ’n vrugtebos?",
    prepping: "Voorbereiding vir rampe?",
    communityFarming: "Gemeenskapsboerdery / onafhanklike lewe?",
    canning: "Inmaak en preserveer?",
    survival: "Oorlewingsvaardighede?",
    specialSkills: "Spesiale vaardighede (opsioneel)",
    specialPlaceholder: "Enigiets anders wat jy na ’n huishouding of grond bring…",
    hintStart: "Antwoord elke Ja of Nee oor grond en vaardighede, begin bo.",
    hintPlant: "Antwoord of jy jou eie vrugte en groente plant.",
    hintFruitForest: "Antwoord of ’n vrugtebos jou interesseer.",
    hintPrepping: "Antwoord of jy vir rampe voorberei.",
    hintCommunity: "Antwoord of gemeenskapsboerdery jou interesseer.",
    hintCanning: "Antwoord of jy inmaak en preserveer.",
    hintSurvival: "Antwoord of jy oorlewingsvaardighede het.",
  },

  family: {
    eyebrow: "Passing · Gesin",
    title: "Kinders, geloofsdiepte, middels",
    text: "Wat jy in ’n metgesel nodig het oor geloofsintensiteit, kinders, en vorige middelgebruik.",
    children: "Kinders",
    wants: { label: "Wil kinders hê", hint: "’n Gesin bou is deel van die visie." },
    doesNotWant: { label: "Wil nie kinders hê nie", hint: "Duidelike nee oor kinders." },
    open: { label: "Oop", hint: "Onderskei — nie weerskante toegesluit nie." },
    hasLivingWith: {
      label: "Het kinders — woon saam met hulle",
      hint: "Kinders is al deel van die daaglikse lewe.",
    },
    requiredFaith: "Minimum geloofsvlak wat jy in ’n metgesel nodig het",
    requiredFaithHint: "10% … 100%. Harde hek wanneer albei kante geantwoord het.",
    acceptsSubstances: "Aanvaar vorige middelgebruik by ’n metgesel?",
    hintChildren: "Kies een kaart oor kinders.",
    hintFaith: "Skuif die minimum geloofsvlak wat jy in ’n metgesel hoop.",
    hintSubstances: "Sê of vorige middelgebruik by ’n metgesel aanvaarbaar is.",
  },

  ancestry: {
    eyebrow: "Passing · Agtergrond",
    title: "Agtergrondvoorkeure",
    text: "Deel jou agtergrond en waarvoor jy oop is by ’n metgesel. Dit vorm net rangorde — dit steek nooit iemand van die dek weg nie.",
    yourBackground: "Jou agtergrond (merk alles wat pas)",
    openToPartner: "Oop daarvoor by ’n metgesel",
    codeDesc: "Kode: {code}",
    anyDesc: "Sterkste voorkeur vir breedte — aanbeveel as jy onseker is.",
    preferenceOnly: "Net ’n voorkeur — nie ’n hek nie.",
    hintOwn:
      "Merk minstens een agtergrond wat jou beskryf. Dit help net rangorde — dit steek nooit iemand weg nie.",
    hintAccepted: "Merk waarvoor jy oop is by ’n metgesel, of “Oop — geen voorkeur”.",
  },

  interests: {
    eyebrow: "Passing · Belangstellings",
    title: "Wat jy geniet",
    text: "Kies minstens een. Oorvleueling help rangorde; stilte word nooit gestraf nie.",
    hint: "Merk minstens een belangstelling.",
  },

  reflection: {
    eyebrow: "Passing · Refleksie",
    title: "In jou eie woorde",
    text: "Hierdie vier antwoorde word volledig gewys en nooit getel nie. Skryf wat waar is.",
    textThree: "Hierdie drie antwoorde word volledig gewys en nooit getel nie. Skryf wat waar is.",
    describeYourself: "Beskryf jouself",
    lifePurpose: "Lewensdoel",
    fifteenYear: "Jy en die liefde van jou lewe oor 15 jaar",
    weaknesses: "Swakpunte",
    hintDescribe: "Beskryf jouself in minstens {min} karakters.",
    hintPurpose: "Skryf jou lewensdoel in minstens {min} karakters.",
    hintVision: "Skryf die 15-jaar-visie in minstens {min} karakters.",
    hintWeaknesses: "Noem ’n swakpunt in minstens {min} karakters.",
  },

  profile: {
    eyebrow: "Profiel",
    title: "Wat is jou inligting?",
    text: "Jou regte naam. UN8 het net geverifieerde mense.",
    firstName: "Voornaam",
    firstNamePlaceholder: "Jou regte naam",
    age: "Ouderdom",
    agePlaceholder: "18+",
    country: "Land",
    countryPlaceholder: "Kies jou land",
    geoDetected: "Bespeur vanaf jou verbinding: {country}. Jy kan dit verander.",
    geoUnavailable: "Kon nie land bespeur nie — kies asseblief joune.",
    city: "Stad",
    cityPlaceholder: "Waar jy gebaseer is",
    sex: "Geslag",
    maleBody: "Ek is ’n man.",
    femaleBody: "Ek is ’n vrou.",
    hintName: "Tik jou voornaam (minstens twee letters).",
    hintAge: "Ouderdom moet 18 of ouer wees.",
    hintCity: "Tik die stad waar jy woon.",
    hintGender: "Kies Man of Vrou sodat passing kan werk.",
  },

  ready: {
    title: "Jy is in.",
    textNamed: "{name}, gaan soek hulle — dan vee die app uit.",
    text: "Gaan soek hulle — dan vee die app uit.",
    summaryAria: "Opstelopsomming",
    christianRules: "Christen · reëls bevestig",
    mediaLine: "ID · video · {photoCount} foto’s · ry {pending}",
    scalesLine: "Skale L{loyalty}/E{honesty}/P{passion}/T{commitment}",
    genderProfession: "{gender} · {profession}",
    sexUnset: "Geslag —",
    professionFallback: "beroep",
    userLine: "Gebruiker {userId}",
    enterMatching: "Sien jou vier",
    needGender: "Gaan terug na die profielstap en kies Man of Vrou, probeer dan weer.",
  },

  match: {
    brandTag: "Passing",
    navOnboarding: "Opstel",
    navReview: "Hersiening",
    navMatching: "Passing",
    navSelection: "Weeklikse keuse",
    navWhoLiked: "Het jou gelike",
    navMessages: "Boodskappe",
    navProfile: "Profiel",
    logOut: "Meld af",
    enterTitle: "Gaan in by passing",
    enterText:
      "Meld aan met dieselfde e-pos as by opstel. Aansoek, poel, hou-vans en passings gebruik almal jou stabiele gebruiker-id.",
    email: "E-pos",
    emailPlaceholder: "jy@voorbeeld.com",
    password: "Wagwoord",
    passwordPlaceholder: "Jou wagwoord",
    logIn: "Meld aan",
    quietSignIn: "Meld aan",
    guestOr: "Of probeer die demodek (teenoorgestelde geslag vier · geen ekstra geslagstap)",
    guestDemo: "Gaan voort met demo",
    guestMan: "Gas as man",
    guestWoman: "Gas as vrou",
    needGender:
      "Kies eers Man of Vrou by opstel (Profielstap) — passing gebruik dit vir teenoorgestelde-geslag-pare.",
    goOnboarding: "Gaan na opstel →",
    guestSession: "Demosessie · demopoel",
    bootDemo: "Jou weeklikse vier word oopgemaak…",
    signInHint: "Reeds ’n lid?",
    closeSignIn: "Sluit",
    man: "man",
    woman: "vrou",
    tabToday: "Weeklikse keuse",
    tabMatches: "Boodskappe ({count})",
    weeklyTitle: "Jou 4 vir hierdie week",
    weeklyTitleCount: "Jou {count} vir hierdie week",
    weeklyCountdown: "Volgende keuse oor {days} dae",
    weeklyCountdownOne: "Volgende keuse oor 1 dag",
    weeklyCountdownSoon: "Volgende keuse binnekort",
    shortWeekCopy:
      "Hierdie week is daar {count}. Ons stel nooit iemand voor wat nie pas nie.",
    shortWeekTwo:
      "Hierdie week is daar twee. Ons stel nooit iemand voor wat nie pas nie.",
    weekDone: "Dis hierdie week se keuse",
    weekDoneText:
      "Jy het almal onderskei wat ons eerlik kon voorstel. Kom terug wanneer die volgende keuse oopgaan.",
    extraReveal: "Wys nog een",
    extraRevealLeft: "{count} ekstra wysing(s) oor",
    whoLikedTitle: "Wie hou van jou",
    whoLikedHint:
      "Like them back and you match. Then chat is more than thirty-three letters.",
    whoLikedLocked:
      "Teken in om name op die weeklikse dek te sien — inkomende harte wys steeds by Boodskappe.",
    whoLikedEmpty: "Niemand nuuts hou nog van jou nie.",
    inboundTitle: "Hou van jou",
    likeBack: "Hou terug",
    likeHeart: "Gee like",
    flame: "Gee vlam",
    flameNoneLeft: "Geen vlam oor hierdie week. Dit kom Maandag terug.",
    flameLead: "Gee {name} ’n vlam.",
    flameOnly: "Net vlam",
    flameSend: "Stuur vlam",
    heartBurstTitle: "Hou-van vir {name}",
    flameBurstTitle: "Vlam vir {name}",
    flameSent: "Jy het {name} ’n vlam gestuur.",
    flipNeedsLike: "Gee ’n like om die kaart om te draai.",
    likedStays: "A like stays. You cannot take it back.",
    composeCancel: "Kanselleer",
    hudAria: "Krediete, harte en vlam",
    menuOpen: "Maak kieslys oop",
    menuClose: "Sluit",
    refreshTitle: "Nuwe vier",
    heartsNoneLeft: "Geen harte oor hierdie week. Jou harte kom Maandag terug.",
    commentLead: "Gee {name} ’n like.",
    commentPlaceholder: "33 letters, nie meer nie",
    commentCount: "{count} / {max}",
    commentSend: "Stuur like",
    heartOnly: "Net hartjie",
    commentTooLong: "Dit is meer as {max} letters. Die hartjie het gegaan; die nota nie.",
    commentAnchors: {
      about: "Oor my",
      lookingFor: "Soek",
      hobbies: "Belangstellings",
      photo: "Foto",
    },
    profileTitle: "Jou profiel",
    profileSub: "Rekening, intekening, en toetsgereedskap.",
    verify: {
      brandTag: "Verifieer",
      title: "Verifieer om te boodskap",
      sub: "Enigeen kan blaai en ’n hartjie stuur. ’n Gesprek het jou ID en ’n kort bevestigingsvideo nodig. Ingedien is genoeg — hersiening kan wag.",
      cta: "Voeg ID en video by",
      videoCta: "Voeg ’n bevestigingsvideo by",
      submitted: "ID en video is in. Jy kan boodskap terwyl ons hersien.",
      done: "Jy is geverifieer.",
      back: "Terug",
      continue: "Gaan voort",
      idEyebrow: "Identiteit",
      videoEyebrow: "Teenwoordigheid",
      idText: "Paspoort of nasionale ID. Niks word openbaar geplaas nie. Ingedien is genoeg om te praat.",
      videoText:
        "’n Kort knippie (ongeveer {seconds} sekondes). Kyk na die kamera. Dit bewys jy is teenwoordig.",
    },
    yourMatches: "Jou boodskappe",
    matchesSub: "Blywende wedersydse belangstelling · {count} uitgaande {likesWord}",
    like: "hou van",
    likes: "hou-vans",
    emptyMatches: "Nog geen wedersydse belangstelling nie. Bly hierdie week se keuse onderskei.",
    valuesScore: "Waardes {score}",
    chatOpen: " · Klets oop",
    tapToChat: " · Tik om te klets",
    personLine: "{name}, {age}",
    cityValues: "{city} · Waardes {score}",
    noProfileYet: "Nog geen profiel nie",
    noProfileText:
      "Voltooi opstel, of maak Profiel oop, dan Begin. Gas-passing is op die ingangskerm as jy net wil kyk.",
    matchingPaused: "Passing onderbreek",
    waitingModeration: "Jou profiel wag op modereringgoedkeuring voordat die dek oopgaan.",
    completeProfileFirst: "Voltooi en dien eers jou profiel in.",
    moderationDemoNote: "Wys demomense sodat jy passing kan probeer terwyl jy wag.",
    noOneYet: "Nog niemand om te wys nie",
    todaysSetDone: "Dis hierdie week se keuse",
    emptyNeverHad:
      "Daar is nog niemand in hierdie week se lys nie. Ons vul nog die poel — maak Keuse oor ’n oomblik weer oop, of kom terug wanneer meer lede goedgekeur is.",
    emptyDone:
      "Jy het hierdie week se keuse deurgegaan. Kom terug wanneer die volgende keuse oopgaan, of stel die dek terug om weer te kyk.",
    likesMayNotStick: " Hou-vans hou dalk nie.",
    poolMeta: "Poel: {pool} · Passings: {matches} · Hou van: {liked}",
    demoPool: "demo",
    livePool: "{source} ({count})",
    resetDeck: "Stel dek terug",
    swapFour: "Nuwe vier · 10 000 krediete",
    memberNew: "Net aangesluit",
    memberDays: "{days}d hier",
    memberWeeks: "{weeks}w hier",
    memberMonths: "{months}ma hier",
    cardStatLoyalty: "LOJ",
    cardStatHonesty: "EER",
    cardStatPassion: "PAS",
    cardStatCommit: "TOE",
    cardStatSocial: "SOS",
    cardStatFaith: "GEL",
    cardStatCharacter: "KAR",
    cardStatPurpose: "DOE",
    cardStatHome: "HUIS",
    cardStatAncestry: "AFK",
    cardStatTemper: "TEM",
    goToProfile: "Gaan na profiel",
    goToProfileChat: "Profiel & klets",
    holdToPeek: "Hou {name} se kaart in om statistieke te sien",
    holdOrOpenProfile: "Hou vir statistieke, tik vir {name} se profiel",
    likeToOpenProfile: "Hou eers van hulle om die volle profiel oop te maak",
    waitLikeBack: "Wag dat {name} terughou van jou — dan oop klets.",
    flipToStats: "Wys {name} se statistieke",
    flipToPhoto: "Wys {name} se foto",
    likeToFlip: "Hou in vir statistieke. Hou van om die profiel oop te maak.",
    swapNoCredits:
      "Nie genoeg krediete om te verfris nie. Gratis ruil en elke intekenaar-verfrissing kos 10 000.",
    likeSent: "Hou van {name}. Ons laat hulle weet — as hulle terug hou van jou, pas julle.",
    packTitle: "Jou vier",
    packSkip: "Tik om voort te gaan",
    newSelection: "Nuwe keuse",
    backToFour: "← Terug na jou vier",
    backOnboarding: "Terug na opstel",
    feedEyebrowDemo: "Weeklikse keuse · Demopoel",
    feedEyebrowLive: "Weeklikse keuse · Poel ({source}, {count})",
    feedTitle: "Onderskei met sorg",
    left: "nog {count}",
    pass: "Slaan oor",
    interested: "♥ Hou van",
    swipeHint:
      "Slaan oor word binne 24 uur vervang wanneer iemand anders pas. Ons vul nooit met ’n swak passing nie.",
    celebrationEyebrow: "Wedersydse belangstelling",
    celebrationTitle: "Dit is ’n passing",
    celebrationText: "{self} · {other}",
    celebrationWhyLabel: "Hoekom julle pas",
    celebrationNote: "",
    celebrationFusing: "Word een pad…",
    celebrationReady: "",
    openChat: "Maak klets oop",
    keepDiscerning: "Bly onderskei",
    cardSeeking: "Soek",
    cardHobbies: "Stokperdjies",
    matchingScore: "Passingtelling",
    affinity: "Passingtelling",
    valuesScoreLabel: "Passingtelling",
    scoreStrong: "Sterk belyning",
    scoreSolid: "Stewige belyning",
    scoreModerate: "Matige belyning",
    scoreDifferent: "Verskillende ritmes",
    characterAxisFoot: "Karakteras sluit die vier pilare in",
    youThem: "Jy {self} · Hulle {other}",
    stampInterest: "Belangstelling",
    stampPass: "Slaan oor",
    explainLikedYou: "Hulle hou al van jou — dit is wedersydse belangstelling wat wag om te gebeur.",
    explainLegacyClose: "Julle waardetellings sit naby mekaar ({score} uit 100).",
    explainLegacyFuller: "’n Vollediger “hoekom” verskyn nadat julle albei die passingsvrae klaarmaak.",
    explainFaith: "Julle geloofsintensiteit is naby — julle volg Jesus met soortgelyke erns.",
    explainCharacter: "Hoe julle mense by die huis behandel, lyn op — vrede, maniere en omgee.",
    explainPurpose: "Julle het julle eie eerlikheid soortgelyk gegradeer — ’n teken van gedeelde erns.",
    explainHome: "Julle deel ’n belangstelling in grond, kos kweek, of ’n selfvoorsienende huis.",
    explainAncestry:
      "Julle verkies albei soortgelyke familie-agtergronde. Dit is ’n voorkeur, nie ’n filter nie — niemand word daarvoor weggesteek nie.",
    explainTemperament: "Julle belangstellings en temperament oorvleuel.",
    explainFallback: "Daar is ’n moontlike passing op die antwoorde wat julle albei ingevul het.",
    explainOverall: "Passingtelling {score}/100",
    scoreBadge: "Passingtelling {score}/100",
    overlapAgree: "Ons stem saam oor",
    overlapDisagree: "Ons sien dit anders oor",
    overlapItems: {
      keepsCommandments: "God se gebooie hou",
      spreadsGospel: "Die evangelie deel",
      grewUpInChurch: "In die kerk grootword",
      peacemaker: "Vredemakers by die huis wees",
      homebuilder: "’n Vreedsame huis bou",
      caringAffectionate: "Omgee en liefde wys",
      wantsPeacefulHome: "’n Vreedsame huishouding wil hê",
      goodManners: "Goeie maniere en respek",
      humorous: "Humor in die daaglikse lewe",
      herbKnowledge: "Kruie en natuurlike middels ken",
      plantsOwnFruitVeg: "Jou eie kos kweek",
      interestedInFruitForest: "Voedselwoude en grond",
      preppingForCalamities: "Voorbereiding vir swaar tye",
      communityFarming: "Gemeenskapsboerdery en selfvoorsiening",
      canningAndPreserving: "Inmaak en preserveer",
      survivalSkills: "Praktiese oorlewingsvaardighede",
      readyForRelationship: "Gereedheid vir ’n blywende verhouding",
      stableChildhood: "’n Stabiele, liefdevolle kinderjare",
      sharedInterests: "{count} gedeelde belangstellings",
      faithIntensity: "Soortgelyke erns oor geloof",
    },
    affinityAxes: {
      faith: "Geloofsintensiteit",
      character: "Karakter en gedrag",
      purpose: "Lewensdoel-belyning",
      home: "Huis en selfvoorsiening",
      ancestry: "Kulturele en agtergrondverwantskap",
      temperament: "Temperamentpassing",
    },
    scaleAxes: {
      loyalty: "Lojaliteit",
      honesty: "Eerlikheid",
      passion: "Passie",
      commitment: "Toewyding",
    },
  },

  chat: {
    brandTag: "Klets",
    unavailableTitle: "Klets nie beskikbaar nie",
    unavailableText: "Hierdie passing ontbreek of hoort nie by jou sessie nie.",
    backToMatches: "Terug na passings",
    backMatches: "← Passings",
    valuesSubscriber: "Waardes {score} · Intekenaar",
    valuesTrial: "Waardes {score} · Proef",
    valuesKept: "Waardes {score} · Passing behou",
    empty:
      "Sê hallo met sorg. Op die gedeelde agterkant sinkroniseer boodskappe na albei fone ná ’n wedersydse passing.",
    placeholder: "Boodskap {name}…",
    ariaMessage: "Boodskap",
    send: "Stuur",
  },

  billing: {
    paywallCopy:
      "Gratis: 4 mense per week (10 000 krediete om te ruil). Intekenaar $4.99: 5 verfrissings per week · VIP $9.99: onbeperk. Een nuwe gesprekbegin per week. Passings wat jy al het, bly vir altyd gratis. Fakturering is net Google Play.",
    signInToMatch: "Meld aan om passing te gebruik.",
    signInFirst: "Meld eers aan.",
    subscriberUntil: "Intekenaar · tot {date}",
    vipUntil: "VIP-klub · tot {date}",
    freePlan: "Gratis · weeklikse vier + krediete",
    renewal: "hernuwing",
    freeTrial: "Gratis proef · {days} dae (eindig {date})",
    soon: "binnekort",
    trialEnded: "Proef verby · weeklikse vier + passings en klets bly",
    freeTrialEnded: "Proef verby · weeklikse vier + passings en klets bly",
    creditsBalance: "{count} krediete",
    creditsUnlimited: "Onbeperkte krediete",
    switchHint: " · weeklikse ruil {cost}",
    subscribe: "Teken in · ${price}/md",
    subscribeEarly: "Teken vroeg in · ${price}/md",
    activeNote: "Intekening aktief — wie hou van jou en ekstra wysings is ontsluit.",
    playOnly:
      "Intekening is net Google Play Billing (app-installasie). Hier is geen web-afrekkening nie.",
    playOnlyShort: "Fakturering net via Google Play — geen webbetaling nie.",
    playSubscribeMember: "Teken in · Lid $4.99/md (Google Play)",
    playSubscribeVip: "Sluit by VIP aan · $9.99/md (Google Play)",
    playRestore: "Herstel Google Play-aankope",
    playUnavailable:
      "Google Play Billing maak oop in die geïnstalleerde app (TWA). Hier is geen web-afrekkening nie.",
    playBusy: "Maak Google Play oop…",
    playError: "Kon nie Play-aankoop voltooi nie. Probeer weer vanuit die app.",
    activateSubscriberQa: "QA: aktiveer Intekenaar (plaaslik)",
    activateVipQa: "QA: aktiveer VIP (plaaslik)",
    enablePush: "Stel my in kennis van hou-vans en passings",
    pushEnabled: "Kennisgewings aan vir hou-vans en passings",
    pushBlocked: "Kennisgewings in blaaier-instellings geblokkeer",
    pushUnavailable: "Stoot benodig VAPID-sleutels van Masco — hou-vans in die app werk steeds.",
  },

  auth: {
    recoveryTitle: "Stoor jou herstelkode",
    recoveryText:
      "Skryf dit nou neer. Dit word een keer gewys. As jy jou wagwoord verloor, is hierdie kode die enigste manier om dit in die toetssluiting te herstel.",
    savedContinue: "Ek het dit gestoor — gaan voort",
    welcomeBack: "Welkom terug",
    createAccount: "Skep jou rekening",
    intro:
      "Handvatsel en wagwoord. Geen e-pos of SMS word gestuur nie. Jou id bly stabiel oor opstel, hersiening en passing.",
    tabLogin: "Meld aan",
    tabRegister: "Registreer",
    handle: "Handvatsel",
    handlePlaceholder: "jy@voorbeeld.com of ’n kort handvatsel",
    passphrase: "Wagwoord",
    passphrasePlaceholder: "Minstens 8 karakters",
    submitLogin: "Meld aan",
    submitRegister: "Skep rekening",
    backWelcome: "Terug na welkom",
  },

  options: {
    origin: {
      african: "Afrika",
      european: "Europees",
      asian: "Asiaties",
      latino: "Latino / Hispanies",
      middleEastern: "Midde-Oosters",
      indigenous: "Inheems",
      mixed: "Gemeng",
      other: "Ander",
      dutch: "Nederlands",
      german: "Duits",
      any: "Oop — geen voorkeur",
    },
    interest: {
      prayer: "Gebed",
      worship: "Aanbidding",
      reading: "Lees",
      hiking: "Stap",
      music: "Musiek",
      cooking: "Kook",
      farming: "Boerdery / tuinmaak",
      sports: "Sport",
      missions: "Sending",
      family: "Gesinslewe",
      crafts: "Handwerk",
      outdoors: "Buitelewe",
    },
  },

  capture: {
    yesNoDefaults: { yes: "Ja", no: "Nee" },
    id: {
      titleEmpty: "Staats-ID",
      titleReady: "ID gereed",
      hintEmpty:
        "Paspoort of nasionale ID. Neem ’n lewendige foto, of kies ’n beeld/PDF. Al vier hoeke sigbaar.",
      hintReady: "{fileName} · {bytes}{saved}",
      savedSuffix: " · gestoor",
      previewAlt: "Staats-ID-voorskou",
      pdfAria: "PDF-dokument gekies",
      takePhoto: "Neem foto",
      retake: "Neem weer",
      chooseFile: "Kies lêer",
      replaceFile: "Vervang lêer",
      remove: "Verwyder",
      uploading: "Laai op…",
      cameraTitle: "Fotografeer jou ID",
      signIn: "Meld aan voordat jy ID oplaai.",
      uploadFailed: "Oplaai het misluk. Probeer weer.",
      badFile: "Kon nie hierdie lêer gebruik nie.",
    },
    video: {
      titleEmpty: "Bevestigingsvideo",
      titleLive: "Kamera lewendig",
      titleReady: "Video gereed",
      hintEmpty: "Sê jou voornaam en dat jy eerlik by UN8 aansluit. 5–15 sekondes.",
      hintReady: "{fileName} · {bytes}{saved}",
      rec: "REC {seconds}s",
      record: "Neem op",
      cameraUpload: "Kamera-oplaai",
      chooseFile: "Kies lêer",
      startRecording: "Begin opname",
      cancel: "Kanselleer",
      stopSave: "Stop en stoor",
      recordAgain: "Neem weer op",
      replaceFile: "Vervang lêer",
      remove: "Verwyder",
      unsupported: "Lewendige opname is hier onbeskikbaar. Gebruik kamera-oplaai of kies ’n lêer.",
      permissionDenied: "Kameratoestemming geweier. Jy kan steeds ’n kort videolêer oplaai.",
      signIn: "Meld aan voordat jy video oplaai.",
      uploadFailed: "Oplaai het misluk. Probeer weer.",
      saveFailed: "Kon nie opname stoor nie.",
      badVideo: "Kon nie hierdie video gebruik nie.",
    },
    photos: {
      count: "{count} / {max} foto’s",
      minimumMet: "Minimum bereik",
      moreRequired: "{n} meer nodig",
      listAria: "Verifikasiefoto’s",
      photoAlt: "Foto {n}",
      removeAria: "Verwyder foto {n}",
      camera: "Kamera",
      takePhoto: "Neem foto",
      chooseFiles: "Kies lêers",
      uploading: "Laai op…",
      hint: "Neem foto maak die lewendige kamera oop. Kies lêers is net vir galerykeuses. Duidelike gesigskote — geen filters wat identiteit verberg nie. Maks {max}.",
      cameraTitle: "Neem ’n foto van jouself",
      signIn: "Meld aan voordat jy foto’s oplaai.",
      someFailed: "Sommige foto’s het nie opgelaai nie. Probeer die misluktes weer.",
      addFailed: "Kon nie foto’s byvoeg nie.",
    },
    liveStill: {
      titleDefault: "Kamera",
      close: "Sluit",
      capture: "Neem",
      cancel: "Kanselleer",
      hint: "Hou stil. Die lewendige kamera bly oop tot jy neem.",
      unavailable: "Kamera is nie in hierdie blaaier beskikbaar nie. Gebruik eerder Kies lêer.",
      permissionDenied: "Kameratoestemming geweier of onbeskikbaar. Gebruik eerder Kies lêer.",
      frameFailed: "Kon nie hierdie raam neem nie.",
      saveFailed: "Kon nie die foto stoor nie.",
    },
    uploadStatus: {
      uploading: "laai op…",
      failed: "oplaai het misluk",
      savedLocally: "plaaslik gestoor",
      uploaded: "opgelaai",
      stored: "geberg",
      awaitingUpload: "Wag op oplaai",
      localFallbackNote: "{error} Lêer is op hierdie toestel gestoor; probeer weer wanneer die teken-eindpunt op is.",
    },
  },
  language: {
    label: "Taal",
    choose: "Kies taal",
  },
  shell: {
    back: "Terug",
    goBackAria: "Gaan terug",
  },
  voiceAssistant: {
    title: "UN8-stemgids",
    fabAria: "Maak stemassistent oop",
    panelAria: "Stemassistentkontroles",
    start: "Begin",
    startAria: "Begin stemgesprek",
    starting: "Begin…",
    stop: "Stop",
    stopAria: "Stop stemgesprek",
    close: "Sluit",
    closeAria: "Sluit stemassistentpaneel",
    mute: "Demp",
    muteAria: "Demp assistentklank",
    unmute: "Ontdemp",
    unmuteAria: "Ontdemp assistentklank",
    statusIdle: "Tik Begin om met die UN8-gids te praat.",
    statusConnecting: "Koppel…",
    statusListening: "Luister — praat wanneer jy gereed is.",
    statusSpeaking: "Praat…",
    statusError: "Verbindingsfout.",
    unavailableNotConfigured: "Stemassistent onbeskikbaar — nie opgestel nie.",
    micDenied: "Mikrofoontoestemming geweier. Laat die mik in blaaier-instellings toe, probeer dan weer.",
    errorGeneric: "Stemassistent kon nie koppel nie. Probeer oor ’n oomblik weer.",
  },

  questionnaire: {
    skipForNow: "Slaan vir eers oor",
    skipConsequence: "Beantwoorde profiele word eerste gewys.",
    confirm: "Gaan voort",
    progressLabel: "{current} van {total}",
    fewSentences: "’n Paar sinne",
    ancestryNote:
      "Dit is ’n voorkeur en vorm net rangorde — dit steek nooit iemand van die dek weg nie.",
  },
};
